import React, { useMemo, useContext } from "react";
import { useLocation } from "react-router-dom";
import BackgroundContext from "./BackgroundContext";

export function useBackground() {
  return useContext(BackgroundContext);
}

export function BackgroundProvider({ children }) {
  const location = useLocation();
  const path = location.pathname.toLowerCase();

  const theme = useMemo(() => {
    const isCheckoutPage = path.includes("/checkout");

    if (
      !isCheckoutPage &&
      (path.includes("resin") ||
        path.includes("/resin-art") ||
        path.includes("/texture-paint") ||
        path.includes("/women") ||
        path.includes("/kidsshirts") ||
        path.includes("wear"))
    ) {
      return {
        background: "#FEB9C4",
        primary: "#FFBAC5",
        accent: "#FFE2E6",
        navbarBg: "#FFFCFC",
        text: "#E75480",
        textSecondary: "#E75480",
        borderColor: "#E79AAE",
        themeName: "resin",
      };
    }

    return {
      background: "#151515",
      navbarBg: "#151515",
      primary: "#151515",
      accent: "#212121",
      text: "#FFFFFF",
      textSecondary: "#000000",
      borderColor: "#262626",
      themeName: "fesishop",
    };
  }, [path]);

  return (
    <BackgroundContext.Provider value={{ theme, path }}>
      {children}
    </BackgroundContext.Provider>
  );
}
